/* eslint-disable prefer-destructuring, class-methods-use-this, no-undef, camelcase, prefer-template */
class Filters {
	constructor() {
		let filterButtons = document.querySelectorAll('.filter-selects__item .title');
		if (filterButtons.length > 0) {
			Array.prototype.forEach.call(filterButtons, (e) => {
				e.addEventListener('click', (event) => {
					/*
										var specifiedElement = event.target.parentElement.querySelector('.filter-selects__list');
										document.addEventListener('click', event => {
											let isClickInside = specifiedElement.contains(event.target)
											if (!isClickInside) {
												Array.prototype.forEach.call(document.querySelectorAll('.filter-selects__item'), (e) => {
													e.classList.remove('opened');
												});
											}
										});			
					*/
					if (event.target.parentElement.classList.contains('opened')) {
						let body = document.querySelector('body')

						console.log(body.getAttribute('style'))
						if (body.getAttribute('style') == 'overflow-y: hidden;') {
							body.style = ''
						}

						event.target.parentElement.classList.remove('opened');
					} else {
						Array.prototype.forEach.call(document.querySelectorAll('.filter-selects__item'), (e) => {
							e.classList.remove('opened');
						});

						if (window.innerWidth < 768) {
							let body = document.querySelector('body')

							body.style.overflowY = 'hidden'
						}

						event.target.parentElement.classList.add('opened');
					}
				});
			});

			Array.prototype.forEach.call(document.querySelectorAll('.filter-select__list-item label'), (e) => {
				e.addEventListener('click', (event) => {
					Array.prototype.forEach.call(event.target.parentElement.parentElement.querySelectorAll('input'), (e2) => { 
						e2.checked = false;
					});
					event.target.parentElement.querySelector('input').checked = true;		
					this.launchQuery();
				});
			});

			Array.prototype.forEach.call(document.querySelectorAll('.remove-filter'), (e) => {
				e.addEventListener('click', (event) => {
					event = event.target;
					if ('IMG' == event.tagName) {
						event = event.parentElement;
					}
					document.querySelector('#' + event.dataset.id).checked = false;
					this.launchQuery();
				});
			})

			document.querySelector('#filter-button').addEventListener('click', (e) => {
				this.launchQuery();
			})
		}
	}

	launchQuery() {
		window.location.href = window.location.href.split('?')[0] + this.getParams();
	}

	getParams() {
		let vars = '';
		Array.prototype.forEach.call(document.querySelectorAll('.filter-select__list-item input'), (e) => {
			if (e.checked) {
				if ('' != vars) {
					vars += '&';
				}
				vars += e.dataset.field + '=' + e.value;
			}
		});
		Array.prototype.forEach.call(document.querySelectorAll('.filter-text'), (e) => {
			if ('' != e.value) {
				if ('' != vars) {
					vars += '&';
				}
				vars += 'f_' + e.id + '=' + e.value;
			}
		});
		if ('' != vars) {
			vars = '?' + vars;
		}
		return vars;
	}
}

export default Filters;
